export default {
  data: () => ({
    custcat: [],
    areas: [],
    custgroup: [],
    resultArray: [],
    resultTotalRows: 0,
    selectAllBranch: false,
    showDatePickers: true,
    tabledata: [],
    userAreasList: [],
    userCustCatList: [],
    userCustGroupList: [],
    selectedAreas: [],
    selectedCustCat: [],
    selectedCustGroup: [],
    selectedDatasets: [],
    selectedBranch: [],
    selectedReport: "Main",
    reportsList: ["Main", "Dimension Analysis", "Customers"],
    showReportDates: false,
    reportDates: [],
    showReportsMenu: false,
    username: "",
    useremail: "",
    userImage: "",
    userDataset: [],
    userAreas: [],
    userCustGroups: [],
    userNKAGroups: [],
    userCusts: [],
    userProds: [],
    userBranches: [],
    userRoles: [],
    signedIn: false,
    showDimensionAnalysis: false,
  }),
};
